import api from './axiosConfig';
import { PRODUCT_B2B_ENDPOINT } from './apiEndpoints';
import { logError } from './errorLogService';

export const fetchProductsB2B = async (countryId) => {

    try {
        const response = await api.get(PRODUCT_B2B_ENDPOINT(countryId));
        return response.data
    } catch (error) {
        console.error("Error fetching hero data", error);

        await logError('product_b2b_fetch', error, {
            endpoint: PRODUCT_B2B_ENDPOINT(countryId),
            countryId,
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        throw error;
    }
};
